import { useSnackbar } from 'notistack';
import { ConfirmDialog } from 'components';
import apiService from 'library/api-service';
import { FormattedMessage } from 'react-intl';
import { Dispatch, SetStateAction, useState } from 'react';
import { ProjectStepItem } from 'pages/project-step-managing/types';
import { removeCommentFromProjectStepTree } from 'pages/project-step-managing/utils';

type DeleteCommentDialogProps = {
  open: boolean;
  id: number | null;
  projectStepId: number | null;
  handleClose: () => void;
  setProjectSteps: Dispatch<SetStateAction<ProjectStepItem[]>>;
};

const DeleteCommentDialog = ({ open, id, projectStepId, handleClose, setProjectSteps }: DeleteCommentDialogProps) => {
  // other hooks
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    if (!id || !projectStepId) return;

    try {
      setLoading(true);

      const response = await apiService.deleteCommentFromProjectStep(id);

      if (response.isSuccess) {
        enqueueSnackbar(
          <FormattedMessage
            id="projectStepManaging.deleteSuccessMessage"
            defaultMessage="Seçili yorumu silme işlemi başarıyla tamamlandı."
          />,
          { variant: 'success' }
        );

        setProjectSteps((prev) => removeCommentFromProjectStepTree(prev, projectStepId, id));

        handleClose();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmDialog
      open={open}
      title={<FormattedMessage id="projectStepManaging.deleteComment" defaultMessage="Yorum Sil" />}
      description={
        <FormattedMessage
          id="projectStepManaging.deleteCommentText"
          defaultMessage="Bu işlem onaylandıktan sonra yorum veritabanından silinecektir. Silme işlemini onaylıyor musunuz?"
        />
      }
      onClose={handleClose}
      onConfirm={handleDelete}
      loading={loading}
      mobileFullScreen={false}
    />
  );
};

export default DeleteCommentDialog;
